import axios from 'axios';
import { toast } from 'react-toastify';
import { URL } from '../constants';
//create axios instance with base use

const base = axios.create({
  baseURL: URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'en-US,en;q=0.9',
  },
});

base.interceptors.request.use((config) => {
  const token = localStorage.getItem('atoken');
  if (token) {
    config.headers.Authorization = `JWT ${token}`;
  }
  return config;
});

base.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    const { status, config } = error.response;

    if (status === 401 && config.url !== '/auth/jwt/create/') {
      localStorage.clear();
      toast.error('Session expired. Please login again.');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default base;
